module.exports = __webpack_public_path__ + "img/gamers-club-anti-cheat.7ad3333a.png";